export enum CryptoRandomString {
  base64 = 'base64', //YMiMbaQl6I
  urlSafe = 'url-safe', //YN-tqc8pOw
  numeric = 'numeric', //8314659141
  distinguishable = 'distinguishable', //CDEHKM
  asciiPrintable = 'ascii-printable', //`#Rt8$IK>B
  alphanumeric = 'alphanumeric', //DMuKL8YtE7
}
